export default __webpack_public_path__ + "static/media/coin.96013223.png";